import React, { useEffect, useMemo, useRef, useState } from "react"
import { X, CalendarDays } from "lucide-react"
import { useTranslation } from "react-i18next"
import { useSmallLaptop } from "../../hooks"
import CardWrapper from "./CardWrapper"
import CurrencySelector from "./CurrencySelector"
import { useDispatch, useSelector } from "react-redux"
import {
  selectAviaSearchDates,
  selectAviaSearchTerminals,
  setAviaSearchParams,
} from "../../../../../app/reducers/book/aviaSearchSlice"
import DateModal from "./DateModal"
import { formatDateArray } from "../../utils/processing/search"

const DateCard = ({ isDeparture = false, onClick, handleSearch }) => {
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation()
  const locale = i18n.language

  const { from, to } = useSelector(selectAviaSearchDates)
  const terminals = useSelector(selectAviaSearchTerminals)
  // services

  const [isOpenModal, setIsOpenModal] = useState(false)
  // const [displayDate, setDisplayDate] = useState("")

  // refs
  const cardRef = useRef(null)

  // services

  // cus hooks
  const isSmallLaptop = useSmallLaptop()

  const hasValue = isDeparture ? from?.some(Boolean) : to?.some(Boolean)

  const displayDate = useMemo(() => {
    const fromArray = Array.isArray(from) ? from : []
    const toArray = Array.isArray(to) ? to : []

    return isDeparture ? formatDateArray(fromArray, locale) : formatDateArray(toArray, locale)
  }, [isDeparture, locale, from, to])

  const label = isDeparture ? t("airform.departure_date") : t("airform.departure_date_back")

  const handleModal = async () => {
    try {
      if (!isOpenModal) {
        await onClick()
      }
    } catch (error) {
    } finally {
      setIsOpenModal(!isOpenModal)
    }
  }

  const handleClear = () => {
    dispatch(setAviaSearchParams({ key: !isDeparture ? "dates.to" : "dates.from", value: [] }))
    dispatch(setAviaSearchParams({ key: "dates.round_trip", value: false }))
    dispatch(setAviaSearchParams({ key: "dates.one_way", value: true }))
  }

  return (
    <CardWrapper>
      <div
        ref={cardRef}
        className="flex items-center overflow-visible h-[45px] gap-4 relative cursor-pointer"
        onClick={handleModal}
      >
        <CalendarDays className="w-5 h-5 text-text-secondary flex shrink-0" />
        <div className="flex flex-col h-full text-sm truncate">
          <span className="text-text-secondary">{label}</span>
          <span className="text-black">
            <span className="text-black">{displayDate || t("admin.select_date")}</span>
          </span>
        </div>
      </div>

      {hasValue && (
        <button
          onClick={handleClear}
          className="absolute top-1/2 -translate-y-1/2 -right-3 w-6 h-6 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors cursor-pointer"
        >
          <X className="w-4 h-4 text-text-secondary" />
        </button>
      )}

      {hasValue && (
        <button
          onClick={handleClear}
          className="absolute top-1/2 -translate-y-1/2 -right-3 w-6 h-6 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors cursor-pointer"
        >
          <X className="w-4 h-4 text-dark-gray" />
        </button>
      )}

      {!isDeparture && <CurrencySelector handleSearch={handleSearch} />}

      <DateModal
        showModal={isOpenModal}
        onClose={handleModal}
        isDeparture={isDeparture}
        className={
          isDeparture
            ? "md:left-0"
            : "md:right-[-240px] lg:right-[-176px] xl:right-[-40px] 2xl:right-0"
        }
      />
    </CardWrapper>
  )
}

export default DateCard
